module.exports = __webpack_public_path__ + "static/media/ic-calendar.cc77338b.svg";